import { createStart, createCsrfMiddleware, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

// Internal email endpoints (auth webhook, delivery-event webhook and template
// preview) authenticate themselves and must never be wrapped in app-level
// redirects, CSRF guards or error pages.
const isInternalEmailPath = (rawUrl: string) => {
  try {
    const { pathname } = new URL(rawUrl);
    return pathname.startsWith("/lovable/");
  } catch {
    return false;
  }
};

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  if (isInternalEmailPath(request.url)) return next();
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

// Start installs this automatically when src/start.ts is absent; defining the
// file opts out, so re-add it explicitly to keep server functions protected
// from cross-site requests.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) =>
    ctx.handlerType === "serverFn" && !isInternalEmailPath(ctx.request.url),
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware, csrfMiddleware],
}));
